import { useTranslation } from "./i18n";
import { isInterfaceLanguage, rememberInterfaceLanguage } from "./i18n/language";
import SelectMenu from "./SelectMenu";
import "./language-switcher.css";

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation("language");
  return (
    <span className="language-switcher">
      <SelectMenu
        iconOnly
        label={t("choose")}
        value={i18n.resolvedLanguage || "zh-HK"}
        options={[
          { value: "zh-HK", label: "繁體中文", lang: "zh-Hant" },
          { value: "en", label: "English", lang: "en" },
        ]}
        icon={
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="19"
            height="19"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <circle cx="12" cy="12" r="9" />
            <ellipse cx="12" cy="12" rx="4" ry="9" />
            <path d="M3 12h18M5 7h14M5 17h14" />
          </svg>
        }
        onChange={(language) => {
          if (!isInterfaceLanguage(language)) return;
          rememberInterfaceLanguage(language);
          void i18n.changeLanguage(language);
        }}
      />
    </span>
  );
}
